module.exports = __webpack_public_path__ + "img/logo-expert.349ba1ef.png";